<template>
  <div v-show="false" />
</template>

<script>
import Swal from 'sweetalert2'
import _ from 'lodash'
import { mapState } from 'vuex'
import { downloadFile } from '@/utils/download-file'
export default {
  name: 'DMReportNotification',
  sockets: {
    connect: function () {
      console.log('Report notification connected')
    },
    reportAvailableForDownloadEvent: async function (data) {
      if (data.requestedBy._id !== this.userId) return
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: this.$t('seurelatorioficoupronto'),
        text: this.$t('cliquenobotaodownloadparabaixarorelatorio'),
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#53933a',
        cancelButtonColor: '#d33',
        confirmButtonText: _.capitalize(this.$t('download')),
        cancelButtonText: _.capitalize(this.$t('cancel'))
      }).then((result) => {
        if (result.isConfirmed) {
          this.download(data.file.file, data.file.originalName)
        }
      })
    }
  },
  computed: {
    ...mapState('user', ['userId'])
  },
  methods: {
    async download(fileUrl, fileName) {
      try {
        await downloadFile(fileUrl, fileName)
      } catch (e) {
        Swal.fire({
          icon: 'error',
          title: this.$t('erro'),
          text: this.$t('erroaoexportardados')
        })
      }
    }
  }
}
</script>
